import { defineMessages } from 'react-intl';
import TeaserBlockDefault from '@fhnw/components/Blocks/Teaser/variations/TeaserBlockDefault';

import { ButtonSchema, messages } from '@fhnw/schemas/button';
import { MediaSchema } from '@fhnw/schemas/media';

const teaserMessages = defineMessages({
  overwrite: {
    id: 'Customize teaser content',
    defaultMessage: 'Customize teaser content',
  },
  overwriteDescription: {
    id: 'Check this box to customize the title, description, or image of the target content item for this teaser. Leave it unchecked to show updates to the target content item if it is edited later.',
    defaultMessage:
      'Check this box to customize the title, description, or image of the target content item for this teaser. Leave it unchecked to show updates to the target content item if it is edited later.',
  },
});

interface TeaserSchemaEnhancerProps {
  schema: {
    fieldsets: [{ fields: string[] }];
    properties: {
      styles: { schema: { properties: {} } };
      actions: {
        title: string;
        widgetOptions: {
          frontendOptions: { widget: string; widgetProps: { schema: any } };
        };
      };
      format: {
        title: any;
        default: string;
        widgetOptions: {
          frontendOptions: {
            widget: string;
            widgetProps: {
              vocabulary: {
                '@id': string;
              };
            };
          };
        };
      };
      focus_point: {
        title: any;
        widgetOptions: {
          frontendOptions: {
            widget: string;
            widgetProps: {
              vocabulary: {
                '@id': string;
              };
            };
          };
        };
      };
      overwrite: { title: string; description: string };
      showTeaserHeading: { title: string; type: string; default: boolean };
      showTeaserImage: { title: string; type: string; default: boolean };
      showTeaserText: { title: string; type: string; default: boolean };
      href: { selectedItemAttrs: string[] };
    };
  };
  formData?: {
    overwrite?: boolean;
    variation?: string;
  };
  intl: {
    formatMessage: (message: any) => string;
  };
}

const teaserSchemaEnhancer = ({
  schema,
  ...props
}: TeaserSchemaEnhancerProps) => {
  schema.properties.styles.schema.properties = {};

  const media = MediaSchema(props);
  schema.properties.format = media.properties.format;
  schema.properties.focus_point = media.properties.focus_point;

  if (props?.formData?.overwrite) {
    if (props?.formData?.variation !== 'fullBleedTeaser') {
      schema.fieldsets[0].fields.push('format');
    }
    schema.fieldsets[0].fields.push('focus_point');
  }

  schema.fieldsets[0].fields.push('actions');
  schema.properties.actions = {
    title: props.intl.formatMessage(messages.Actions),
    widgetOptions: {
      frontendOptions: {
        widget: 'custom_object_list_widget',
        widgetProps: {
          schema: ButtonSchema(props),
        },
      },
    },
  };

  schema.properties.overwrite.title = props.intl.formatMessage(
    teaserMessages.overwrite,
  );
  schema.properties.overwrite.description = props.intl.formatMessage(
    teaserMessages.overwriteDescription,
  );

  if (props?.formData?.variation !== 'fullBleedTeaser') {
    schema.fieldsets[0].fields.push('showTeaserHeading');
    schema.properties.showTeaserHeading = {
      title: 'Teaserüberschrift anzeigen',
      type: 'boolean',
      default: true,
    };
    schema.fieldsets[0].fields.push('showTeaserImage');
    schema.properties.showTeaserImage = {
      title: 'Teaserbild anzeigen',
      type: 'boolean',
      default: true,
    };
    schema.fieldsets[0].fields.push('showTeaserText');
    schema.properties.showTeaserText = {
      title: 'Teasertext anzeigen',
      type: 'boolean',
      default: true,
    };
    schema.properties.href.selectedItemAttrs.push('ShowTeaserImage');
    schema.properties.href.selectedItemAttrs.push('ShowTeaserText');
    schema.properties.href.selectedItemAttrs.push('ShowTeaserHeading');
  }

  return schema;
};

export const teaserBlockVariations = [
  {
    id: 'default',
    title: 'Standard',
    isDefault: true,
    template: TeaserBlockDefault,
    schemaEnhancer: teaserSchemaEnhancer,
  },
  {
    id: 'infobox',
    title: 'Infobox',
    isDefault: false,
    template: TeaserBlockDefault,
    schemaEnhancer: teaserSchemaEnhancer,
  },
  {
    id: 'fullBleedTeaser',
    title: 'Full Bleed Teaser',
    isDefault: false,
    template: TeaserBlockDefault,
    schemaEnhancer: teaserSchemaEnhancer,
  },
];
